module.exports = function() {
  return new Worker(__webpack_public_path__ + "f0c3a8eae5ab7f30c342.worker.js");
};